const main = 'reports'
const relativeRoutes = {
  relativePage: `${main}/*`,
  relativeDPR: `DPR`,
  relativePL: 'PL',
  relativeDaily: 'Daily',
  relativeNewContracts: 'New-Contracts',
  relativeUnshipped: 'Unshipped',
}

const routes = {
  DPR: `/${main}/${relativeRoutes.relativeDPR}`,
  PL: `/${main}/${relativeRoutes.relativePL}`,
  Daily: `/${main}/${relativeRoutes.relativeDaily}`,
  NewContracts: `/${main}/${relativeRoutes.relativeNewContracts}`,
  Unshipped: `/${main}/${relativeRoutes.relativeUnshipped}`,
}

const ReportsRoutes = { ...relativeRoutes, ...routes }

export default ReportsRoutes
